export interface PageContext {
  path: string;
  referrer: string;
  search: string;
  title: string;
  url: string;
}

export interface ScreenContext {
  width: number;
  height: number;
}

export function getPageContext(): PageContext {
  return {
    path: window.location.pathname,
    referrer: document.referrer,
    search: window.location.search,
    title: document.title,
    url: window.location.href,
  };
}

export function getScreenContext(): ScreenContext {
  return {
    width: window.screen.width,
    height: window.screen.height,
  };
}

export function getGlobalContext(): Record<string, unknown> {
  return {
    page: getPageContext(),
    screen: getScreenContext(), // Standard Segment spec puts screen under context.screen? Or just separate? Usually context.screen.
    userAgent: navigator.userAgent,
    locale: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}
